import { request } from '../helpers/request';
import { PaginatedResponse, TranslationKey } from '../helpers/types';

export interface CreateKeyPayload {
  key: string;
  sourceText: string;
  description?: string;
  context?: string;
  tags?: string[];
}

export type ListKeysParams = {
  page?: number;
  limit?: number;
  search?: string;
};

export interface ImportKeysResult {
  total: number;
  created: number;
  updated: number;
  skipped: number;
  deleted: number;
}

export const keysApi = {
  list: (projectId: string, params: ListKeysParams = {}) =>
    request<PaginatedResponse<TranslationKey>>(`/projects/${projectId}/keys`, {
      params,
    }),

  create: (projectId: string, payload: CreateKeyPayload) =>
    request<TranslationKey>(`/projects/${projectId}/keys`, {
      method: 'POST',
      body: payload,
    }),

  import: (projectId: string, keys: CreateKeyPayload[], prune = false) =>
    request<ImportKeysResult>(`/projects/${projectId}/keys/import`, {
      method: 'POST',
      body: { keys, prune },
    }),

  update: (
    projectId: string,
    keyId: string,
    payload: Partial<CreateKeyPayload>,
  ) =>
    request<TranslationKey>(`/projects/${projectId}/keys/${keyId}`, {
      method: 'PATCH',
      body: payload,
    }),

  remove: (projectId: string, keyId: string) =>
    request<void>(`/projects/${projectId}/keys/${keyId}`, {
      method: 'DELETE',
    }),
};
